module.exports = __webpack_public_path__ + "img/39d1aed.png";